import { RecentlyDeletedTableCell } from '~/components/RecentlyDeleted/components/RecentlyDeletedTableCell';
import { type RecentlyDeletedItemType } from '~/components/RecentlyDeleted/types';
import { getTableColumnWidth } from '~/components/RecentlyDeleted/utils/getTableColumnWidth';

const TYPE_LABELS: Record<RecentlyDeletedItemType, string> = {
  asset: 'Asset',
  board: 'Board',
  library: 'Library',
  customField: 'Custom field',
};

export const RecentlyDeletedTableCellType = ({ type }: { type: RecentlyDeletedItemType }) => {
  return (
    <RecentlyDeletedTableCell width={getTableColumnWidth('type')}>
      <span>{TYPE_LABELS[type]}</span>
    </RecentlyDeletedTableCell>
  );
};
